import { createStyles, Radio } from '@mantine/core';
import { useMemo } from 'react';

import { textStyles } from '~/domains/design-system/Text';

import type { TFilterSingleSelect } from '../types';

const valueToString = (value: unknown): string =>
  typeof value === 'string' ? value : JSON.stringify(value);

const useStyles = createStyles((theme) => ({
  option: {
    padding: `${theme.other.spacing._16}px 0`,

    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.colors.gray2[0]}`,
    },
  },
  labelWrapper: {
    flexGrow: 1,
  },
  label: {
    ...textStyles['headline-medium'],
    paddingLeft: theme.other.spacing._16,
  },
}));

function FilterSingleSelect<VT>({
  filter,
  onSubmit,
  value = [],
}: {
  filter: TFilterSingleSelect<VT>;
  onSubmit: (value: VT[]) => void;
  value: VT[];
}) {
  const { classes } = useStyles();
  const stringifiedValue = useMemo(
    () => value.map((v) => valueToString(v)).filter(Boolean),
    [value]
  );

  return (
    <div>
      {filter.options.map((option) => (
        <div className={classes.option} key={JSON.stringify(option.value)}>
          <Radio
            name={filter.key}
            label={option.label}
            checked={
              option.value
                ? stringifiedValue.includes(valueToString(option.value))
                : stringifiedValue.length === 0
            }
            onChange={() => {
              onSubmit([option.value]);
            }}
            classNames={{
              label: classes.label,
              labelWrapper: classes.labelWrapper,
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default FilterSingleSelect;
